document.addEventListener('DOMContentLoaded', function() {
    var faqItems = document.querySelectorAll('.Faq__Item');

    faqItems.forEach(function(item) {
        var button = item.querySelector('.Faq__Question');
        button.addEventListener('click', function() {
            var answerWrapper = this.nextElementSibling;
            var isExpanded = item.getAttribute('aria-expanded') === 'true';

            // Umschalten der Sichtbarkeit
            answerWrapper.style.height = isExpanded ? '0' : 'auto';
            answerWrapper.setAttribute('aria-hidden', isExpanded ? 'true' : 'false');

            // Umschalten des aria-expanded Attributs für das Item und den Button
            item.setAttribute('aria-expanded', !isExpanded);
        });
    });
});